import { render, staticRenderFns } from "./CouponOpsCenter.vue?vue&type=template&id=472c41dc&scoped=true&lang=pug&"
import script from "./CouponOpsCenter.vue?vue&type=script&lang=ts&"
export * from "./CouponOpsCenter.vue?vue&type=script&lang=ts&"
import style0 from "./CouponOpsCenter.vue?vue&type=style&index=0&id=472c41dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c41dc",
  null
  
)

export default component.exports